// extracted by mini-css-extract-plugin
export default {"message":"styles_message__tceiF","buttons":"styles_buttons__fMkmJ"};